import { useState, useEffect } from 'react'

import { useRouter } from 'next/router'

import { Locale, OurServices } from '@/service/api/landingPage'
import { getLPTranslationData } from '@/utils/getLPTranslationData'

export const useOurServicesContainer = () => {
  const router = useRouter()
  const locale = (router.locale || 'pt-BR') as Locale

  const [data, setData] = useState<OurServices>(
    () =>
      getLPTranslationData({
        landingPage: 'shared',
        container: 'ourServices',
        locale,
      }) as OurServices,
  )

  useEffect(() => {
    const translationsObject = getLPTranslationData({
      landingPage: 'shared',
      container: 'ourServices',
      locale,
    }) as OurServices

    setData(translationsObject)
  }, [locale])

  return {
    data,
  }
}
